import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white edit-course-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "form-group mb-15 mb-sm-20 mb-md-25" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Course Title "),
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      class: "form-control shadow-none rounded-0 text-black",
      placeholder: "e.g. AI Machine Learning"
    })
  ])
], -1)
const _hoisted_5 = { class: "col-md-12" }
const _hoisted_6 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Course Description ", -1)
const _hoisted_8 = { class: "mb-0" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-12\"><div class=\"form-group mb-15 mb-sm-20 mb-md-25\"><label class=\"d-block text-black fw-semibold mb-10\"> Select Category </label><select class=\"form-select shadow-none fw-semibold rounded-0\"><option selected>Artificial Inteligence (AI)</option><option value=\"1\">Web Development</option><option value=\"2\">Entrepreneurship</option><option value=\"3\">Management</option><option value=\"4\">Business Strategy</option></select></div></div><div class=\"col-md-6\"><div class=\"form-group mb-15 mb-sm-20 mb-md-25\"><label class=\"d-block text-black fw-semibold mb-10\">Price</label><div class=\"input-group\"><span class=\"input-group-text rounded-0 fs-14 fw-bold text-primary\"> $ </span><input type=\"text\" class=\"form-control shadow-none rounded-0 text-black\" placeholder=\"e.g. 120.00\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group mb-15 mb-sm-20 mb-md-25\"><label class=\"d-block text-black fw-semibold mb-10\"> Discount </label><div class=\"input-group\"><span class=\"input-group-text rounded-0 fs-14 fw-bold text-primary\"> % </span><input type=\"text\" class=\"form-control shadow-none rounded-0 text-black\" placeholder=\"e.g. 15\"></div></div></div><div class=\"col-md-12\"><div class=\"form-group mb-15 mb-sm-20 mb-md-25\"><label class=\"d-block text-black fw-semibold mb-10\"> Select Tags </label><input type=\"text\" class=\"form-control shadow-none rounded-0 text-black\" placeholder=\"e.g. AI\"><div class=\"members-list\"><div class=\"d-inline-block bg-gray rounded-1 fs-12 fw-medium text-primary p-5\"> Machine Learning <button type=\"button\" class=\"bg-transparent p-0 border-0 lh-1 transition\"><i class=\"flaticon-close\"></i></button></div><div class=\"d-inline-block bg-gray rounded-1 fs-12 fw-medium text-primary p-5\"> App Dev <button type=\"button\" class=\"bg-transparent p-0 border-0 lh-1 transition\"><i class=\"flaticon-close\"></i></button></div><div class=\"d-inline-block bg-gray rounded-1 fs-12 fw-medium text-primary p-5\"> Design <button type=\"button\" class=\"bg-transparent p-0 border-0 lh-1 transition\"><i class=\"flaticon-close\"></i></button></div></div></div></div>", 4)
const _hoisted_13 = { class: "col-md-12" }
const _hoisted_14 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Course Preview Image ", -1)
const _hoisted_16 = { class: "col-md-12" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold text-black mb-12 mb-md-15 mb-lg-20" }, " Course Sections ", -1)
const _hoisted_18 = {
  class: "accordion mb-15 mb-sm-20 mb-md-25 mb-lg-30",
  id: "tableOfContentAccordion"
}
const _hoisted_19 = { class: "accordion-item border-0" }
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<button class=\"accordion-button d-block w-100 text-start text-black fs-14 fs-md-15 fs-lg-16 fw-medium rounded-0 bg-white border-0\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#TableContentCollapseOne\" aria-expanded=\"true\" aria-controls=\"TableContentCollapseOne\"><div class=\"d-sm-flex align-items-center justify-content-between\"><div class=\"d-flex align-items-center\"><div class=\"number bg-primary text-center text-white rounded-circle fs-13 fw-semibold\"> 1 </div> Welcome to the course! </div><ul class=\"d-flex align-items-center mt-10 mt-sm-0 ps-0 mb-0 list-unstyled\"><li class=\"position-relative fw-medium fs-14 text-muted\"><i class=\"flaticon-book\"></i> 5 lectures </li><li class=\"position-relative fw-medium fs-14 text-muted\"><i class=\"flaticon-clock\"></i> 11 mins </li></ul></div></button>", 1)
const _hoisted_21 = {
  id: "TableContentCollapseOne",
  class: "accordion-collapse collapse show",
  "data-bs-parent": "#tableOfContentAccordion"
}
const _hoisted_22 = { class: "accordion-body" }
const _hoisted_23 = { class: "ps-0 mb-0 list-unstyled" }
const _hoisted_24 = { class: "d-flex justify-content-between" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "01:22", -1)
const _hoisted_27 = { class: "d-flex justify-content-between" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "05:10", -1)
const _hoisted_30 = { class: "d-flex justify-content-between" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "00:46", -1)
const _hoisted_33 = { class: "d-flex justify-content-between" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "03:26", -1)
const _hoisted_36 = { class: "d-flex justify-content-between" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "00:23", -1)
const _hoisted_39 = { class: "accordion-item border-0" }
const _hoisted_40 = /*#__PURE__*/_createStaticVNode("<button class=\"accordion-button collapsed d-block w-100 text-start text-black fs-14 fs-md-15 fs-lg-16 fw-medium rounded-0 bg-white border-0\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#TableContentCollapseTwo\" aria-expanded=\"true\" aria-controls=\"TableContentCollapseTwo\"><div class=\"d-sm-flex align-items-center justify-content-between\"><div class=\"d-flex align-items-center\"><div class=\"number bg-primary text-center text-white rounded-circle fs-13 fw-semibold\"> 2 </div> Python Setup </div><ul class=\"d-flex align-items-center mt-10 mt-sm-0 ps-0 mb-0 list-unstyled\"><li class=\"position-relative fw-medium fs-14 text-muted\"><i class=\"flaticon-book\"></i> 6 lectures </li><li class=\"position-relative fw-medium fs-14 text-muted\"><i class=\"flaticon-clock\"></i> 12 mins </li></ul></div></button>", 1)
const _hoisted_41 = {
  id: "TableContentCollapseTwo",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#tableOfContentAccordion"
}
const _hoisted_42 = { class: "accordion-body" }
const _hoisted_43 = { class: "ps-0 mb-0 list-unstyled" }
const _hoisted_44 = { class: "d-flex justify-content-between" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "01:22", -1)
const _hoisted_47 = { class: "d-flex justify-content-between" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "05:10", -1)
const _hoisted_50 = { class: "d-flex justify-content-between" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "00:46", -1)
const _hoisted_53 = { class: "d-flex justify-content-between" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "03:26", -1)
const _hoisted_56 = { class: "d-flex justify-content-between" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "00:23", -1)
const _hoisted_59 = { class: "accordion-item border-0" }
const _hoisted_60 = /*#__PURE__*/_createStaticVNode("<button class=\"accordion-button collapsed d-block w-100 text-start text-black fs-14 fs-md-15 fs-lg-16 fw-medium rounded-0 bg-white border-0\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#TableContentCollapseThree\" aria-expanded=\"true\" aria-controls=\"TableContentCollapseThree\"><div class=\"d-sm-flex align-items-center justify-content-between\"><div class=\"d-flex align-items-center\"><div class=\"number bg-primary text-center text-white rounded-circle fs-13 fw-semibold\"> 3 </div> Python Objects &amp; Data Structures Basics </div><ul class=\"d-flex align-items-center mt-10 mt-sm-0 ps-0 mb-0 list-unstyled\"><li class=\"position-relative fw-medium fs-14 text-muted\"><i class=\"flaticon-book\"></i> 8 lectures </li><li class=\"position-relative fw-medium fs-14 text-muted\"><i class=\"flaticon-clock\"></i> 43 mins </li></ul></div></button>", 1)
const _hoisted_61 = {
  id: "TableContentCollapseThree",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#tableOfContentAccordion"
}
const _hoisted_62 = { class: "accordion-body" }
const _hoisted_63 = { class: "ps-0 mb-0 list-unstyled" }
const _hoisted_64 = { class: "d-flex justify-content-between" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "01:22", -1)
const _hoisted_67 = { class: "d-flex justify-content-between" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "05:10", -1)
const _hoisted_70 = { class: "d-flex justify-content-between" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "00:46", -1)
const _hoisted_73 = { class: "d-flex justify-content-between" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "03:26", -1)
const _hoisted_76 = { class: "d-flex justify-content-between" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "00:23", -1)
const _hoisted_79 = { class: "accordion-item border-0" }
const _hoisted_80 = /*#__PURE__*/_createStaticVNode("<button class=\"accordion-button collapsed d-block w-100 text-start text-black fs-14 fs-md-15 fs-lg-16 fw-medium rounded-0 bg-white border-0\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#TableContentCollapseFour\" aria-expanded=\"true\" aria-controls=\"TableContentCollapseFour\"><div class=\"d-sm-flex align-items-center justify-content-between\"><div class=\"d-flex align-items-center\"><div class=\"number bg-primary text-center text-white rounded-circle fs-13 fw-semibold\"> 4 </div> Python Comparison Operators </div><ul class=\"d-flex align-items-center mt-10 mt-sm-0 ps-0 mb-0 list-unstyled\"><li class=\"position-relative fw-medium fs-14 text-muted\"><i class=\"flaticon-book\"></i> 3 lectures </li><li class=\"position-relative fw-medium fs-14 text-muted\"><i class=\"flaticon-clock\"></i> 33 mins </li></ul></div></button>", 1)
const _hoisted_81 = {
  id: "TableContentCollapseFour",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#tableOfContentAccordion"
}
const _hoisted_82 = { class: "accordion-body" }
const _hoisted_83 = { class: "ps-0 mb-0 list-unstyled" }
const _hoisted_84 = { class: "d-flex justify-content-between" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "01:22", -1)
const _hoisted_87 = { class: "d-flex justify-content-between" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_89 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "05:10", -1)
const _hoisted_90 = { class: "d-flex justify-content-between" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_92 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "00:46", -1)
const _hoisted_93 = { class: "d-flex justify-content-between" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_95 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "03:26", -1)
const _hoisted_96 = { class: "d-flex justify-content-between" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_98 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "00:23", -1)
const _hoisted_99 = { class: "accordion-item border-0" }
const _hoisted_100 = /*#__PURE__*/_createStaticVNode("<button class=\"accordion-button collapsed d-block w-100 text-start text-black fs-14 fs-md-15 fs-lg-16 fw-medium rounded-0 bg-white border-0\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#TableContentCollapseFive\" aria-expanded=\"true\" aria-controls=\"TableContentCollapseFive\"><div class=\"d-sm-flex align-items-center justify-content-between\"><div class=\"d-flex align-items-center\"><div class=\"number bg-primary text-center text-white rounded-circle fs-13 fw-semibold\"> 5 </div> Python Statements </div><ul class=\"d-flex align-items-center mt-10 mt-sm-0 ps-0 mb-0 list-unstyled\"><li class=\"position-relative fw-medium fs-14 text-muted\"><i class=\"flaticon-book\"></i> 10 lectures </li><li class=\"position-relative fw-medium fs-14 text-muted\"><i class=\"flaticon-clock\"></i> 1 hour </li></ul></div></button>", 1)
const _hoisted_101 = {
  id: "TableContentCollapseFive",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#tableOfContentAccordion"
}
const _hoisted_102 = { class: "accordion-body" }
const _hoisted_103 = { class: "ps-0 mb-0 list-unstyled" }
const _hoisted_104 = { class: "d-flex justify-content-between" }
const _hoisted_105 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_106 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "01:22", -1)
const _hoisted_107 = { class: "d-flex justify-content-between" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_109 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "05:10", -1)
const _hoisted_110 = { class: "d-flex justify-content-between" }
const _hoisted_111 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_112 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "00:46", -1)
const _hoisted_113 = { class: "d-flex justify-content-between" }
const _hoisted_114 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_115 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "03:26", -1)
const _hoisted_116 = { class: "d-flex justify-content-between" }
const _hoisted_117 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_118 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "00:23", -1)
const _hoisted_119 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-12\"><h5 class=\"fw-bold text-black mb-12 mb-md-15 mb-lg-20\"> Add More Sections </h5></div><div class=\"col-md-6\"><div class=\"form-group mb-15 mb-sm-20 mb-md-25\"><label class=\"d-block text-black fw-semibold mb-10\"> Section Title </label><input type=\"text\" class=\"form-control shadow-none rounded-0 text-black\" placeholder=\"e.g. Introduction\"></div></div><div class=\"col-md-6\"><div class=\"form-group mb-15 mb-sm-20 mb-md-25\"><label class=\"d-block text-black fw-semibold mb-10\"> Duration </label><input type=\"text\" class=\"form-control shadow-none rounded-0 text-black\" placeholder=\"e.g. 1:25\"></div></div><div class=\"col-md-6\"><div class=\"form-group mb-15 mb-sm-20 mb-md-25\"><label class=\"d-block text-black fw-semibold mb-10\"> Sub-section Title </label><input type=\"text\" class=\"form-control shadow-none rounded-0 text-black\" placeholder=\"e.g. Introduction\"></div></div><div class=\"col-md-6\"><div class=\"form-group mb-15 mb-sm-20 mb-md-25\"><label class=\"d-block text-black fw-semibold mb-10\"> Sub-section Duration </label><input type=\"text\" class=\"form-control shadow-none rounded-0 text-black\" placeholder=\"e.g. 4:32\"></div></div><div class=\"col-md-12\"><div class=\"form-group mb-15 mb-sm-20 mb-md-25\"><label class=\"d-block text-black fw-semibold mb-10\"> Upload Video Or Content </label><div class=\"file-upload text-center position-relative\"><i class=\"flaticon-video\"></i><span class=\"d-block text-muted\"> Drop Files Here Or <span class=\"text-black fw-medium position-relative\"> Click To Upload </span></span><input type=\"file\" class=\"d-block shadow-none border-0 position-absolute start-0 end-0 top-0 bottom-0 z-1 opacity-0\"></div></div></div><div class=\"col-md-12\"><div class=\"d-flex align-items-center justify-content-between\"><button class=\"default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success\" type=\"submit\"> Save Course </button><button type=\"button\" class=\"bg-transparent p-0 border-0 text-danger lh-1 fw-medium\"><i class=\"flaticon-delete lh-1 me-1 position-relative top-2\"></i><span class=\"position-relative\">Delete Course</span></button></div></div>", 7)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuillEditor = _resolveComponent("QuillEditor")!
  const _component_ImageUpload = _resolveComponent("ImageUpload")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", null, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_QuillEditor, {
                  theme: "snow",
                  placeholder: "Descripción",
                  toolbar: "full"
                })
              ])
            ])
          ]),
          _hoisted_9,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_component_ImageUpload)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("ul", _hoisted_23, [
                      _createElementVNode("li", _hoisted_24, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_25,
                            _createTextVNode(" Welcome Challenge! ")
                          ]),
                          _: 1
                        }),
                        _hoisted_26
                      ]),
                      _createElementVNode("li", _hoisted_27, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_28,
                            _createTextVNode(" Why AI? ")
                          ]),
                          _: 1
                        }),
                        _hoisted_29
                      ]),
                      _createElementVNode("li", _hoisted_30, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_31,
                            _createTextVNode(" Course Structure ")
                          ]),
                          _: 1
                        }),
                        _hoisted_32
                      ]),
                      _createElementVNode("li", _hoisted_33, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_34,
                            _createTextVNode(" Installing Anaconda ")
                          ]),
                          _: 1
                        }),
                        _hoisted_35
                      ]),
                      _createElementVNode("li", _hoisted_36, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_37,
                            _createTextVNode(" Use ChatGPT to Build AI More Efficiently ")
                          ]),
                          _: 1
                        }),
                        _hoisted_38
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _hoisted_40,
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("ul", _hoisted_43, [
                      _createElementVNode("li", _hoisted_44, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_45,
                            _createTextVNode(" Welcome Challenge! ")
                          ]),
                          _: 1
                        }),
                        _hoisted_46
                      ]),
                      _createElementVNode("li", _hoisted_47, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_48,
                            _createTextVNode(" Why AI? ")
                          ]),
                          _: 1
                        }),
                        _hoisted_49
                      ]),
                      _createElementVNode("li", _hoisted_50, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_51,
                            _createTextVNode(" Course Structure ")
                          ]),
                          _: 1
                        }),
                        _hoisted_52
                      ]),
                      _createElementVNode("li", _hoisted_53, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_54,
                            _createTextVNode(" Installing Anaconda ")
                          ]),
                          _: 1
                        }),
                        _hoisted_55
                      ]),
                      _createElementVNode("li", _hoisted_56, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_57,
                            _createTextVNode(" Use ChatGPT to Build AI More Efficiently ")
                          ]),
                          _: 1
                        }),
                        _hoisted_58
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_59, [
                _hoisted_60,
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("ul", _hoisted_63, [
                      _createElementVNode("li", _hoisted_64, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_65,
                            _createTextVNode(" Welcome Challenge! ")
                          ]),
                          _: 1
                        }),
                        _hoisted_66
                      ]),
                      _createElementVNode("li", _hoisted_67, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_68,
                            _createTextVNode(" Why AI? ")
                          ]),
                          _: 1
                        }),
                        _hoisted_69
                      ]),
                      _createElementVNode("li", _hoisted_70, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_71,
                            _createTextVNode(" Course Structure ")
                          ]),
                          _: 1
                        }),
                        _hoisted_72
                      ]),
                      _createElementVNode("li", _hoisted_73, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_74,
                            _createTextVNode(" Installing Anaconda ")
                          ]),
                          _: 1
                        }),
                        _hoisted_75
                      ]),
                      _createElementVNode("li", _hoisted_76, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_77,
                            _createTextVNode(" Use ChatGPT to Build AI More Efficiently ")
                          ]),
                          _: 1
                        }),
                        _hoisted_78
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_79, [
                _hoisted_80,
                _createElementVNode("div", _hoisted_81, [
                  _createElementVNode("div", _hoisted_82, [
                    _createElementVNode("ul", _hoisted_83, [
                      _createElementVNode("li", _hoisted_84, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_85,
                            _createTextVNode(" Welcome Challenge! ")
                          ]),
                          _: 1
                        }),
                        _hoisted_86
                      ]),
                      _createElementVNode("li", _hoisted_87, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_88,
                            _createTextVNode(" Why AI? ")
                          ]),
                          _: 1
                        }),
                        _hoisted_89
                      ]),
                      _createElementVNode("li", _hoisted_90, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_91,
                            _createTextVNode(" Course Structure ")
                          ]),
                          _: 1
                        }),
                        _hoisted_92
                      ]),
                      _createElementVNode("li", _hoisted_93, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_94,
                            _createTextVNode(" Installing Anaconda ")
                          ]),
                          _: 1
                        }),
                        _hoisted_95
                      ]),
                      _createElementVNode("li", _hoisted_96, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_97,
                            _createTextVNode(" Use ChatGPT to Build AI More Efficiently ")
                          ]),
                          _: 1
                        }),
                        _hoisted_98
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_99, [
                _hoisted_100,
                _createElementVNode("div", _hoisted_101, [
                  _createElementVNode("div", _hoisted_102, [
                    _createElementVNode("ul", _hoisted_103, [
                      _createElementVNode("li", _hoisted_104, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_105,
                            _createTextVNode(" Welcome Challenge! ")
                          ]),
                          _: 1
                        }),
                        _hoisted_106
                      ]),
                      _createElementVNode("li", _hoisted_107, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_108,
                            _createTextVNode(" Why AI? ")
                          ]),
                          _: 1
                        }),
                        _hoisted_109
                      ]),
                      _createElementVNode("li", _hoisted_110, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_111,
                            _createTextVNode(" Course Structure ")
                          ]),
                          _: 1
                        }),
                        _hoisted_112
                      ]),
                      _createElementVNode("li", _hoisted_113, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_114,
                            _createTextVNode(" Installing Anaconda ")
                          ]),
                          _: 1
                        }),
                        _hoisted_115
                      ]),
                      _createElementVNode("li", _hoisted_116, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_117,
                            _createTextVNode(" Use ChatGPT to Build AI More Efficiently ")
                          ]),
                          _: 1
                        }),
                        _hoisted_118
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_119
        ])
      ])
    ])
  ]))
}